import React from 'react'
import cx from 'classnames'

import Icon, { icons, IconName } from 'components/_new/ui/Icon/Icon'
import DummyImage from 'components/_new/ui/DummyImage/DummyImage'

import s from './ButtonIcon.scss'


export type ButtonIconProps = {
  icon?: IconName
  compact?: boolean
  compactMobile?: boolean
  className?: string
  iconClassName?: string
}

const ButtonIcon: React.FunctionComponent<ButtonIconProps> = ({ icon, compact, compactMobile, className, iconClassName }) => {
  if (icon && !icons[icon]) {
    console.error(`There is no icon with name "${icon}"`)
  }

  return (
    <span className={cx(s.iconContainer, className)}>
      {
        Boolean(icon) && (
          <Icon className={cx(s.icon, s[icon], iconClassName)} name={icon} />
        )
      }
      <DummyImage className={cx(s.dummy, {
        [s.dummyCompact]: !icon && compact,
        [s.dummyCompactMobile]: !icon && compactMobile,
      })} />
    </span>
  )
}


export default ButtonIcon
